/** @format */

import {cloneElement, useState} from 'react';

import {useTheme} from '@mui/material/styles';

import {measureTextWidth} from 'helpers/measureTextWidth';

import {YAxisTickProps} from '../types';

const YAxisTickSVG = ({
  x = 0,
  y = 0,
  payload,
  data,
  onSegmentClick,
  maxLabelWidth,
  yAxisWidth,
}: YAxisTickProps) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  if (!payload) return null;

  const row = data[payload.index];

  const iconSize = 16;
  const gap = 8;
  const textOffsetY = 5;

  const handleClick = () => {
    if (onSegmentClick && row?.id) {
      onSegmentClick(row.id);
    }
  };

  const fillColor = isHovered
    ? theme.palette?.primary?.main
    : theme.palette?.semantic_dark?.surface.onSurface;

  // Используем максимальную ширину для всех лейблов или измеряем текущий текст точно
  const textWidth = maxLabelWidth ?? measureTextWidth(payload.value, 14, 400);
  const totalWidth = iconSize + 2 * gap + textWidth;
  const rectHeight = 24;
  const paddingHorizontal = 4;

  // Вычисляем offset для позиционирования: используем yAxisWidth или fallback на 190
  const xOffset = yAxisWidth ? yAxisWidth + gap : 242;

  return (
    <g
      transform={`translate(${x - xOffset}, ${y})`}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{cursor: onSegmentClick ? 'pointer' : 'default'}}
    >
      {/* Фоновый прямоугольник */}
      {isHovered && (
        <rect
          x={-paddingHorizontal}
          y={-rectHeight / 2}
          width={totalWidth}
          height={rectHeight}
          rx={8}
          ry={8}
          fill={theme.palette?.semantic_dark?.surface.surface2}
        />
      )}

      {row?.icon && (
        <g transform={`translate(0, ${-iconSize / 2})`}>
          {cloneElement(row.icon as React.ReactElement, {
            width: iconSize,
            height: iconSize,
            fill: fillColor,
          })}
        </g>
      )}

      <text
        x={iconSize + gap}
        y={textOffsetY}
        fill={fillColor}
        fontSize='14px'
        fontWeight={400}
        style={{lineHeight: '16px'}}
      >
        {payload.value}
      </text>
    </g>
  );
};

export default YAxisTickSVG;
